export const alertsConstants = {
  OPEN_ALERT: 'OPEN_ALERT',
  CLOSE_ALERT: 'CLOSE_ALERT',
  MESSAGE_HAS_BEEN_READ: 'MESSAGE_HAS_BEEN_READ',
  SET_MESSAGES: 'SET_MESSAGES',
};
